import frenchMessages from 'ra-language-french'
import { TranslationMessages } from 'react-admin'
import { PrepaymentTargetType } from '../types/Prepayments'

import { fileCopy } from './pages/fileCopy'
import { mediaFiles } from './pages/mediaFiles'
import { statements } from './pages/statements'
import { users } from './pages/users'
import { videoPromotion } from './pages/videoPromotion'

export const frMessages: TranslationMessages = {
  ...frenchMessages,
  _generics: {
    name: 'Nom',
    label: 'Label',
    address: 'Adresse',
    address2: 'Adresse (ligne 2)',
    id: 'Identifiant',
    email: 'Email',
    password: 'Mot de passe',
    catalog: 'Catalogue',
    status: 'Statut',
    from: 'de',
    to: 'à',
    fromIncluded: 'de (inclus)',
    toIncluded: 'à (inclus)',
    error: 'Erreur',
    unknownError: 'Erreur inconnue',
    productionYear: 'Année de Production',
    directorsAndAuthors: 'Réalisateurs & Auteurs',
    product: 'Collection',
    productType: 'Type de collection',
    generic: 'Générique',
    artwork: 'Oeuvre',
    statement: 'Statement',
    code: 'Code',
    import: 'Importer',
    create: 'Créer',
    edit: 'Éditer',
    display: 'Afficher',
    confirm: 'Confirmer',
    save: 'Sauvegarder',
    delete: 'Supprimer',
    disable: 'Désactiver',
    file: 'Fichier',
    size: 'Taille',
    undefined: 'Non défini',
    unavailable: 'Indisponible',
    createAndAssign: 'Créer et Assigner',
    backToList: 'Retourner à la liste',
    noData: 'Aucune donnée',
    notProvided: 'Non renseigné',
    displayMore: 'Afficher plus',
    hide: 'Cacher',
    optional: 'Optionnel',
    appliedOn: 'Appliqué sur',
    cancel: 'Annuler',
    export: 'Exporter',
    close: 'Fermer',
    errors: 'Erreurs',
    published: 'Publiée',
    publishedAt: 'Publiée le',
    yes: 'Oui',
    no: 'Non',
    with: 'Avec',
    without: 'Sans',
    translate: 'Traduire',
    beneficiary: 'Ayant-Droit',
    youtubeClaims: 'Claims',
    date: 'Date',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    day: 'Jour',
    seconds: 'secondes',
    target: 'Cible',
    type: 'Type',
    title: 'Titre',
    subtitles: 'Sous-titres',
    synopsis: 'Synopsis',
    youtubeChannelId: 'ID Chaîne YouTube',
    youtubeUrl: 'Lien YouTube',
    selected: 'sélectionné(s)',
    configuration: 'Configuration',
    result: 'Résultat',
    results: 'Résultats',
    noResult: 'Pas de résultat',
    refineSearch:
      '%{smart_count} résultat, affinez la recherche pour voir les autres |||| %{smart_count} résultats, affinez la recherche pour voir les autres',
    noChannel: 'Pas de chaîne',
    groupBy: 'Grouper par',
    createdAt: 'Date de création',
    updatedAt: 'Mise à jour',
    languages: 'Langues',
    mainlanguage: 'Langue principale',
    additionalLanguages: 'Langues additionnelles',
    informations: 'Informations',
    videos: 'Vidéos',
    video: 'Vidéo',
    links: 'Liens',
    views: 'Vues',
    sections: 'Sections',
    performances: 'Performances',
    revenues: 'Revenus',
    pdfs: 'PDFs',
    csvs: 'CSVs',
    month: {
      _title: 'Mois',
      1: 'Janvier',
      2: 'Février',
      3: 'Mars',
      4: 'Avril',
      5: 'Mai',
      6: 'Juin',
      7: 'Juillet',
      8: 'Août',
      9: 'Septembre',
      10: 'Octobre',
      11: 'Novembre',
      12: 'Décembre',
    },
    year: 'Année',
    quarter: 'Trimestre',
    semester: 'Semestre',
    playlist: 'Playlist',
    playlists: 'Playlists',
    youtubeChannel: 'Chaîne YouTube',
    youtubeChannels: 'Chaînes YouTube',
    youtubeAssets: 'Assets YouTube',
    subTask: 'Sous-tâche',
    assetId: 'Asset ID',
    step: 'Étape',
    search: 'Rechercher',
    next: 'Suivant',
    previous: 'Précédent',
    preview: 'Prévisualisation',
    filters: 'Filtres',
    productTypes: 'Types de collections',
    source: 'Source',
    destination: 'Destination',
    correct: 'Corriger',
    logo: 'Logo',
    finish: 'Finaliser',
    merge: 'Regrouper',
    dissociate: 'Dissocier',
    update: 'Mettre à jour',
    transfer: 'Transférer',
    errorOccured: 'Une erreur est survenue',
    standard: 'Standard',
    basic: 'Simplifié',
    artworkChannel: 'Par oeuvre & chaîne',
    ok: 'Ok',
    period: 'Période',
    actions: 'Actions',
    refresh: 'Rafraîchir',
    all_one: 'Tout',
    all_male: 'Tous',
    all_female: 'Toutes',
    andXOthers: 'et %{smart_count} autre |||| et %{smart_count} autres',
  },
  pages: {
    login: {
      _title: 'Connexion',
      forgotPassword: 'Mot de passe oublié',
      backToLogin: 'Retour à la page de connexion',
      passwordRules: '8 caractères min.',
      newPassword: {
        title: 'Nouveau mot de passe',
        description: 'Le mot de passe a bien été modifié',
      },
      resetPassword: {
        title: 'Réinitialisation du mot de passe',
        description:
          'Un email contenant un lien vient de vous être envoyé afin de réinitialiser votre mot de passe',
      },
      errors: {
        userNotFound: 'Utilisateur non trouvé',
      },
    },
    youtubeChannels: {
      _title: 'Chaînes YouTube',
      subscribersCount: "Nbre d'Abonnés",
      videosCount: 'Nbre de Vidéos',
      viewsCount: 'Nbre de Vues',
      cms: 'CMS',
      tags: 'Tags',
      description: 'Description',
      isOwnedByLogicomix: 'Géré par Logicomix',
      defaultBeneficiary: 'Ayant-droit associé automatiquement',
      defaultProduct: 'Collection associée automatiquement',
      linkToYouTube: 'Voir sur YouTube',
      isAutoMonetizationEnabled: 'Monétisation automatique',
      autoMonetizationPolicyId: 'PolicyID Monétisation automatique',
      isAutoTagUpdateEnabled: 'Mise à jour automatique des tags',
      isAutoSubtitlesTranslationEnabled: 'Traduction automatisée des sous-titres',
      subtitlesLanguages: 'Langues de traduction des sous-titres',
      subtitleMainLanguage: 'Langue principale de traduction',
      additionalSubtitlesLanguages: 'Langues additionnelles de traduction',
      defaultUploadTags: 'Tags par défaut',
      defaultUploadDescription: 'Description par défaut',
      autoTags: 'Tags automatiques',
      autoTagsCommaSeparated: 'séparés par des virgules',
      isAutoInsertSubscribeEndScreenEnabled: "Insertion automatique de l'écran de fin de vidéo",
      autoDefaultVideoLanguage: 'Langue par défaut des vidéos',
      autoAdsPatternTooltip: `Les coupures publicitaires dépendent de la routine de monétisation choisie.</br></br>
        YouTube n'accepte les midrolls que sur les vidéos de 8 minutes ou plus : sur une vidéo plus courte, seuls le pré-roll et le post-roll activés dans la routine sont placés.</br></br>
        Les routines se définissent dans « Routines de monétisation ».`,
      adsInsertionPresetId: 'Routine de monétisation',
      clickupListId: 'ID de la liste ClickUp',
    },
    beneficiaries: {
      _title: 'Ayants-Droits',
      _tabs: {
        1: 'informations',
        2: 'collections',
        3: 'taux de royautés',
        4: 'statements',
        5: 'avances de royautés',
      },
      allBeneficiaries: 'Tous les ayants-droits',
      createStatement: 'Nouveau statement',
      regenerateStatements: 'Regénerer les statements sélectionnés',
      contactFirstName: 'Prénom Contact',
      contactName: 'Nom Contact',
      dearPolite: {
        title: 'Formule de politesse',
        options: {
          single_male: 'Cher',
          single_female: 'Chère',
          plural_male: 'Chers',
          plural_female: 'Chères',
        },
      },
      beneficiaryType: "Type d'Ayant-Droit",
      contactEmail: 'Adresse email contact',
      downloadCatalogCsv: 'Catalogue au format CSV',
      downloadAssetsCsv: 'Tous les assets au format CSV',
      rate: 'Taux',
      addRate: 'Ajouter un taux',
      rateInvalid:
        'Les taux ne sont pas valides : ils ne peuvent pas se superposer, et la période de début doit toujours être antérieure ou égale à la période de fin.',
      addBeneficiary: 'Ajouter un Ayant-Droit',
      imagePlaceholder: 'Glisser-déposer des images ici ou cliquer pour sélectionner une image',
      isAutoCorrected: 'Création automatique des oeuvres ?',
      defaultProductId: 'Collection à utiliser automatiquement',
      defaultProductTypeId: 'Type de collection à utiliser automatiquement',
      defaultDatavizPreset: 'Preset de performance associé',
      statementNames: {
        statement: 'Statement standard',
        basicStatement: 'Statement simplifié',
        artworkChannelStatement: 'Statement par oeuvre & chaine',
      },
      statementSettings: {
        title: 'Réglages des statements',
        introduction: 'Introduction',
        globalInformation: 'Informations génériques',
        firstPageLXGreetings: 'Page de garde (signée Yann)',
        firstPageLXGreetingsError: 'Incompatible les informations génériques',
        productTypes: 'Performances par type de collections',
        products: 'Performances par collections',
        artworks: 'Performances par oeuvres',
        shorts: 'Revenus provenant des shorts',
        adSubscriptionBreakdown: 'Distinction revenus publicitaires / abonnements',
        monthlyComparison: 'PDF: Comparaison mensuelle',
        yearlyComparison: 'PDF: Comparaison annuelle',
      },
      mediaUploadGoogleDriveFolderId: 'ID du dossier Google Drive',
    },
    compilations: {
      _title: 'Compilations',
      compilationName: 'Nom de la compilation',
      mainArtwork: 'Oeuvre de référence',
      linkedArtworks: 'Oeuvres liées',
      addLinkedArtwork: 'Ajouter une oeuvre liée',
      createCompilation: {
        title: 'Créer une compilation',
        toast_createCompilationSuccess: 'La compilation a été créée avec succès',
        toast_createCompilationError: 'Erreur de création de la compilation',
      },
      editCompilation: {
        title: 'Éditer une compilation',
        toast_editCompilationSuccess: 'La compilation a été éditée avec succès',
        toast_editCompilationError: 'Erreur de création de la compilation',
      },
      deleteCompilationModal: {
        title: "Suppression d'une compilation",
        description: 'Êtes-vous sûr de vouloir supprimer la compilation %{name} ?',
        success: 'La compilation a bien été supprimée',
        error: 'Erreur de suppression de la compilation',
      },
    },
    products: {
      _title: 'Collections',
      _tabs: {
        1: 'informations',
        2: 'œuvres',
        3: 'taux spécifiques',
        4: 'avances de royautés',
      },
      productType: 'Type de Collection',
      broadcaster_one: 'Diffuseur',
      broadcaster_other: 'Diffuseurs',
      specificRate: 'Taux Spécifique',
      specificRateExplaination:
        "Il est possible de spécifier un taux particulier pour une collection. Si une collection n'a pas de taux, alors le taux de l'ayant-droit sera utilisé.",
      beneficiary: 'Ayant-droit',
      addProduct: 'Ajouter une Collection',
      modal_transferProductBeneficiary: 'Transférer la collection vers un autre ayant-droit',
      modal_currentBeneficiary: 'Ayant-droit actuel',
      modal_impacted: {
        intro: 'Ce changement impactera',
        artworks: '%{smart_count} oeuvre |||| %{smart_count} oeuvres',
        rows: '%{smart_count} ligne des imports |||| %{smart_count} lignes des imports',
      },
      modal_noImpactedRows: "Ce changement n'impactera aucune oeuvre ni aucune ligne des imports",
      toast_transferSuccess: 'Le transfert de collection a été effectué avec succès',
      toast_transferError: 'Erreur lors du transfert de collection',
    },
    artworks: {
      _title: 'Oeuvres',
      artworkName: 'Nom original de l’oeuvre ',
      artworkCode: 'Code oeuvre',
      originalArtworkCode: 'Code oeuvre originale',
      addArtwork: 'Ajouter une Oeuvre',
      refreshClaims: 'Rafraîchir la liste des claims',
      mergeArtworks: 'Regrouper des oeuvres',
      mergeArtworksDescription:
        'Veuillez sélectionner les oeuvres que vous souhaiter rassembler avec "%{name}".',
      dissociateArtworks: {
        title: 'Dissocier un asset',
        description:
          "Veuillez sélectionner l'oeuvre à laquelle que vous souhaitez rattacher l'asset %{assetId}.",
        noFinancialDataToDissociate: 'Aucunes données financières à dissocier',
        createArtwork: {
          title: "Création d'une oeuvre",
          createForProduct: 'Créer une oeuvre rattachée à %{productName}',
          error: 'Erreur - Impossible de créer cette oeuvre',
        },
      },
      withoutEmptyAssets: 'Filtrer les oeuvres sans assets',
      beneficiaryArtworks: "Oeuvres de l'ayant droit",
      idNumber: 'IDNumber / ISAN',
      youtubeChannelUnavailable: "La chaîne Youtube n'est pas disponible pour cet asset",
      modal_transferArtworkProduct: "Transférer l'oeuvre vers une autre collection",
      modal_chooseBeneficiaryToFilter:
        'Veuillez choisir un ayant-droit afin de filtrer les collections disponibles',
      modal_currentBeneficiary: 'Ayant-droit actuel',
      modal_currentProduct: 'Collection actuelle',
      modal_impactedRows:
        'Ce changement impactera %{smart_count} ligne des imports |||| Ce changement impactera %{smart_count} lignes des imports',
      modal_noImpactedRows: "Ce changement n'impactera aucune ligne des imports",
      toast_refreshClaimsSucceeded: 'La liste des claims a bien été rafraîchie',
      linkToYouTubeStudio: 'Voir sur YouTube Studio',
      hasFootprint: 'Protégé sur Content ID',
      availableVersions: 'Versions disponibles',
      mainTask: 'Tâche principale',
      dubbingType: 'Type de doublage',
      directorsAndAuthors: 'Réalisateurs & Auteurs',
      synopsis: 'Synopsis',
      placeholders: {
        selectArtworks: 'Sélectionner une oeuvre',
      },
    },
    youtubeRawImports: {
      _title: 'Rapports de Ventes',
      newReportFromAPI: 'Importer les rapports automatiquement',
      newReport: 'Importer un nouveau rapport',
      source: 'CMS',
      importType: "Type d'import",
      importSuccess: 'Imports terminés',
      importTypes: {
        asset_summary_adj: 'Ads - ADJ Asset summary',
        asset_summary: 'Ads - Asset summary',
        red_music_asset: 'RED - Music - Rawdata Asset',
        red_non_music_asset: 'RED - Rawdata Asset',
        ecommerce_paid_feature: 'ECommerce - Paid Feature',
        shorts_non_music_subscriptions_video: 'SHORTS - Non Music - Subscriptions Video',
        shorts_non_music_ads_video: 'SHORTS - Non Music - Ads Video',
        channel_adjustment: 'Channel - Adjustments summary',
        affiliate_tax_refund: 'Affiliate - Tax refund summary',
        affiliate_payment_summary: 'Affiliate - Payment summary',
      },
      importTypesAuto: {
        content_owner_asset_ad_revenue_summary_a1: 'Ads - Asset summary',
        content_owner_music_asset_red_revenue_raw_a1: 'RED - Music - Rawdata Asset',
        content_owner_non_music_asset_red_revenue_raw_a1: 'RED - Rawdata Asset',
        content_owner_asset_ad_adjustment_revenue_summary_a1: 'Ads - ADJ Asset summary',
        content_owner_shorts_ad_revenue_summary_a2: 'SHORTS - Non Music - Ads Video',
        content_owner_shorts_red_revenue_video_summary_a1:
          'SHORTS - Non Music - Subscriptions Video',
      },
      conversionRateDollarToEuros: 'Taux de Conversion $ > €',
      totalRevenue: 'CA $',
      totalRevenueInEuros: 'CA €',
      fileChecks: {
        badFileName:
          "Attention, le nom du fichier n'a pas l'air de correspondre aux paramètres entrés :",
        badSource: 'le CMS du fichier ne semble pas être <i>%{source}</i>',
        badDate: 'la période du fichier ne semble pas être <i>%{date}</i>',
        badFiletype: "l'export attendu est le <i>_%{fileType}_</i>",
        expectedFileName:
          "Le fichier attendu est <i>%{expectedFileName}</i>. Si vous l'avez renommé, ne tenez pas compte de ce message !",
      },
      progress_yt: {
        steps: {
          reading: 'Lecture du fichier...',
          refreshing_youtube_channels: 'Récupération des chaînes YouTube...',
          matching_existing_assets: 'Matching avec les assets existants...',
          calling_yt_api: "Récupération des assets via l'API YouTube...",
          error: "Une erreur est survenue, l'import n'a pas pu être integré.",
          success: "L'import a été effectué avec succès.",
        },
        step1: "Création d'un nouvel import Youtube",
      },
      dropzonePlaceholder:
        'Glisser-déposer des fichiers ici ou cliquer pour selectionner un fichier',
      treatedImport: 'Traitement terminé',
      error: "Erreur lors de l'import",
      treatmentInProgress: 'Traitement en cours',
      toast_importError: "Erreur lors de l'import",
      toast_importSuccess: 'Le rapport de vente a bien été importé',
      createdAt: 'Date de création',
      appliedTo: 'Appliqué sur %{period}',
      applyToOtherStatementPeriod: 'Appliquer aux statements d’une autre période',
    },
    importsAmendment: {
      _title: 'Correction des imports',
      assetId: 'Asset ID',
      assetTitle: 'Titre Vidéo',
      showOnlyMissing: 'Afficher uniquement les éléments incomplets',
      showOnlyMissingAssetChannels: 'Afficher uniquement les éléments sans chaîne',
      createAllArtworks: 'Créer toutes les Oeuvres',
      creationInProgress: 'Création des oeuvres en cours…',
      allArtworksCreationSuccess: 'Toutes les oeuvres ont été créées avec succès',
      allArtworksCreationError: "Une erreur s'est produite lors de la création des oeuvres",
      previousAssetNoArtwork: 'Asset sans Oeuvre précedent',
      nextAssetNoArtwork: 'Asset sans Oeuvre suivant',
      subtext_amendAssetTitle: "Merci d'ajouter les titres manquants aux différentes vidéos",
      subtext_amendBeneficiary:
        "Merci d'ajouter les ayants-droits de ces nouvelles oeuvres avant de passer à l'étape suivante",
      subtext_amendProduct:
        "Merci d'ajouter les collections de ces nouvelles oeuvres avant de passer à l'étape suivante",
      subtext_amendProduct2:
        'Pour la sélection multiple, seuls des lignes partageant le même ayant-droit pourront être sélectionnées.',
      subtext_amendArtworks:
        "Merci de compléter les informations de chacunes de ces nouvelles oeuvres afin de finaliser l'import du rapport de ventes",
      toast_editTitleError: "Erreur lors de l'edition du nom",
      toast_editTitleSuccess: 'Le titre a bien été modifié',
      toast_editYoutubeChannelError: "Erreur lors de l'edition de la chaîne YouTube",
      toast_editBeneficiaryError: "Erreur lors de l'edition de l'ayant-droit",
      toast_editBeneficiarySuccess: "L'ayant-droit a bien été modifié",
      toast_editChannelError: "Erreur lors de l'edition de la chaîne",
      toast_editChannelSuccess: 'La chaîne a bien été modifiée',
      toast_editBulkBeneficiarySuccess: 'Les ayant-droits ont bien été modifiés',
      toast_addBeneficiarySuccess: "L'ayant-droit a bien été ajouté",
      toast_editProductError: "Erreur lors de l'edition de la collection",
      toast_editProductSuccess: 'La collection a bien été modifiée',
      toast_editBulkProductSuccess: 'Les collections ont bien été modifiées',
      toast_addProductSuccess: 'La collection a bien été ajoutée',
      toast_addProductError: "Erreur lors de l'ajout du collection",
      toast_editArtworkSuccess: "L'oeuvre a bien été modifiée",
      toast_editArtworkError: "Erreur lors de l'edition du l'oeuvre",
      toast_addArtworkSuccess: "L'oeuvre a bien été ajoutée",
      toast_finalizeError: "Erreur lors de la finalisation de l'import",
      autoAssignBeneficiariesModal: {
        title: 'Assignation automatique des ayants-droits',
        message:
          'Les ayant-droits seront assignés d\'après les réglages "ayant-droit par défaut" sur les chaînes YouTube.',
        noPreview: 'Aucun rattachement automatique detecté.',
        previewRow:
          '<strong>%{smart_count} ligne</strong> sera assignée à <strong>%{beneficiaryName}</strong> (%{youtubeChannelName}) |||| <strong>%{smart_count} lignes</strong> seront assignées à <strong>%{beneficiaryName}</strong> (%{youtubeChannelName})',
        previewRowWithproduct:
          '<strong>%{smart_count} ligne</strong> sera assignée à <strong>%{beneficiaryName} / %{defaultProductName}</strong> (%{youtubeChannelName}) |||| <strong>%{smart_count} lignes</strong> seront assignées à <strong>%{beneficiaryName} / %{defaultProductName}</strong> (%{youtubeChannelName})',
        toast_autoAssignBeneficiariesSuccess:
          "L'assignation des ayants-droits a été effectuée avec succès",
        toast_autoAssignBeneficiariesError:
          "Erreur lors de l'assignation automatique des ayants-droits",
      },
      autoAssignProductsModal: {
        title: 'Assignation automatique des Collections',
        description:
          'Les collections seront automatiquement assignées d\'après les réglages "Collection par défaut" et/ou "Type de collection par défaut" sur les Ayants-Droits.',
        noPreview: 'Aucun rattachement automatique detecté.',
        footNote: "Les oeuvres seront crées automatiquement lors de l'assignation",
        rowWithDefaultProduct:
          '<strong>%{smart_count} oeuvre</strong> sera créée et assignée à la collection <strong>%{defaultProductName}</strong> (%{beneficiaryName}) |||| <strong>%{smart_count} oeuvres</strong> seront créées et assignées à la collection <strong>%{defaultProductName}</strong> (%{beneficiaryName})',
        rowWithoutDefaultProduct:
          '<strong>%{smart_count} collection</strong> et <strong>%{smart_count} oeuvre</strong> de type <strong>%{defaultProductTypeName}</strong> seront créées et rattachées à <strong>%{beneficiaryName}</strong> |||| <strong>%{smart_count} collections</strong> et <strong>%{smart_count} oeuvres</strong> de type <strong>%{defaultProductTypeName}</strong> seront créées et rattachées à <strong>%{beneficiaryName}</strong>',
        toast_autoAssignProductsSuccess:
          "L'assignation et la création des collections et des oeuvres a été effectuée avec succès",
        toast_autoAssignProductsError: "Erreur lors de l'assignation automatique des collections",
      },
    },
    statements,
    fileCopy,
    youtubeClaims: {
      videoTitle: 'Titre de la video',
      studioClaimsUrl: 'Voir les claims (studio)',
      studioClaimUrl: 'Lien vers le claim (studio)',
      studioVideoUrl: 'Lien vers la vidéo (studio)',
      studioVideoYTUrl: 'Lien vers la vidéo (YT)',
      videoViews: 'Nombre de vues',
      isPartnerUploaded: 'Mis en ligne par le partenaire',
    },
    analytics: {
      _title: 'Performances',
      selectBeneficiary: 'Sélectionnez un/des ayant(s)-droits',
      selectCMS: 'Sélectionnez un/des CMS',
      selectProduct: 'Sélectionnez une/des collection(s)',
      selectProductType: 'Sélectionnez un/des type(s) de collection',
      selectArtwork: 'Sélectionnez une/des oeuvre(s)',
      selectRevenueTypes: 'Sélectionnez un/des type(s) de revenu',
      selectYoutubeChannels: 'Sélectionnez une/des chaîne(s) Youtube',
      selectMetric: 'Sélectionnez une donnée à afficher',
      videos: 'Videos',
      presets: 'Presets',
      savePreset: 'Sauvegarder un preset',
      presetName: 'Nom du preset',
      metric: 'Donnée',
      revenueType: 'Type',
      groupBy: {
        noGroupBy: 'Pas de groupe',
        productId: 'Collections',
        productTypeId: 'Types de collection',
        artworkId: 'Oeuvres',
        youtubeAssetChannelId: 'Chaînes Youtube',
        beneficiaryId: 'Ayants-droit',
        cms: 'CMS',
        countryCode: 'Pays',
        revenueType: 'Type',
      },
      revenueTypes: {
        youtube_horizontal: 'Youtube Horizontal',
        ecommerce: 'Ecommerce',
        shorts: 'Shorts',
      },
      defineAsDefaultPreset: "Définir comme preset par défaut pour l'ayant-droit",
      metrics: {
        'analytics.comments': 'Commentaires',
        'analytics.dislikes': 'Dislikes',
        'analytics.likes': 'Likes',
        'analytics.shares': 'Partages',
        'analytics.views': 'Vues',
        'analytics.watchTimeMinutes': 'Durée de visionnage (en minutes)',
        'revenues.partnerRevenuePerAsset': 'Revenus YouTube (en euros)',
        'revenues.partnerRevenuePerAssetPartnerProvided': 'Revenus YouTube Officiels (en euros)',
        'revenues.partnerRevenuePerAssetUGC': 'Revenus YouTube UGC (en euros)',
        'statements.beneficiaryRevenueInEuros': 'Royautés ayant-droit (en euros)',
        'statements.revenueInEuros': 'Revenus (en euros)',
        'statements.revenuePartnerProvidedInEuros': 'Revenus Officiels (en euros)',
        'statements.revenueUGCInEuros': 'Revenus UGC (en euros)',
        'statementAdditionals.beneficiaryRevenueInEuros': 'Royautés additionnels (en euros)',
        'statementAdditionals.revenueInEuros': 'Revenus additionnels (en euros)',
      },
      metricsSections: {
        analytics: 'Performances',
        revenues: 'Revenus',
        statements: 'Statements',
        statementAdditionals: 'Additionnels',
      },
      units: {
        comments: 'commentaires',
        dislikes: 'dislikes',
        likes: 'likes',
        watchTimeMinutes: 'minutes',
        shares: 'partages',
        views: 'vues',
      },
      exportToCsv: 'Exporter en CSV',
      toast_exportToCsvError: "L'export en CSV a échoué",
      toast_exportToCsvTooManyResults:
        "L'export contient trop de lignes : réduisez la période, les filtres ou le regroupement",
      dataError: "Les données n'ont pas pu être chargées",
      tooManyResults:
        'Trop de résultats à afficher : réduisez la période, les filtres ou le regroupement.',
      truncatedGroupsTitle: 'Affichage limité aux %{shownGroupsCount} premiers résultats',
      truncatedGroups:
        "%{groupBy} : seuls les %{shownGroupsCount} premiers sur %{groupsCount} sont affichés, classés par « %{metric} ». Les totaux couvrent bien l'ensemble. Affinez les filtres pour voir les autres.",
      toast_createPresetSuccess: 'Le preset a été créé avec succès',
      toast_createPresetError: 'Erreur lors de la création de preset',
      toast_setDefaultPresetSuccess:
        'Le preset a été assigné à %{beneficiaryName} par défaut avec succès',
      toast_setDefaultPresetError: "Erreur lors de l'assignation par défaut de preset",
      modal_confirmSetDefaultPreset:
        "Êtes-vous sûr de vouloir assigner le preset %{presetName} à l'ayant-droit %{beneficiaryName} ?",
    },
    automatedTreatments: {
      _title: 'Traitements auto.',
      monetization: 'Monétisation',
      translation: 'Traduction',
      patterns: 'Routines de monétisation',
      monetizationAssetId: 'Monétisation Asset ID',
      monetizedAt: 'Date de monétisation',
      insertedTags: 'Tag insérés',
      insertedTagsAt: "Date d'insertion des tags",
      publishedOnYoutubeAt: 'Date de publication',
      titleTranslation: 'Traduction titre',
      descriptionTranslation: 'Traduction description',
      subtitlesTranslation: 'Traduction sous-titres',
      translatedAt: 'Date de traduction',
      translationError: 'Erreurs de traduction',
      noMainCaption:
        'Sous-titre manquant sur la vidéo pour la langue principale de traduction (%{lang})',
      translateSubtitles: 'Traduire les sous-titres',
      subtitlesTranslatedForVideos:
        "Les sous-titres seront traduits pour toutes les vidéos de la chaine sélectionnée (ou toutes les vidéos des chaînes ayant l'option activée).",
      error: 'Erreur',
      ignoredTitleDescriptionErrors: {
        title_too_long: 'Titre trop long',
      },
      numberOfLanguages: '%{smart_count} langues',
      progressModal: {
        title: 'Traduction des titres, descriptions et sous-titres',
        inProgress: 'Traitement en cours',
        success: 'Traitement terminé',
        error: 'Une erreur est survenue',
      },
    },
    monetizationPatterns: {
      about: {
        title: "Description d'une routine",
        description:
          "Une routine décrit l'emplacement des coupures publicitaires placées automatiquement sur les vidéos des chaînes qui l'utilisent : pré-roll, midrolls fixes, midroll récurrent, post-roll.",
      },
      search: 'Rechercher une routine',
      patternsCount: '%{smart_count} routine |||| %{smart_count} routines',
      generalInformation: 'Informations générales',
      adBreaks: 'Coupures publicitaires',
      hasPreroll: 'Pré-roll',
      hasPostroll: 'Post-roll',
      fixedMidrolls: 'Midrolls fixes',
      recurringMidroll: 'Midroll récurrent',
      recurringMidrollStart: 'Premier midroll à',
      recurringMidrollInterval: 'puis toutes les',
      recurringSummary: 'dès %{start}, toutes les %{interval}',
      recurringNote:
        'Les deux champs se remplissent ensemble : les laisser vides désactive le midroll récurrent.',
      minVideoLengthNote:
        "YouTube n'accepte les midrolls que sur les vidéos de 8 minutes ou plus : sur une vidéo plus courte, seuls le pré-roll et le post-roll sont placés.",
      timecodePlaceholder: 'mm:ss',
      addTimecode: 'Ajouter un timecode',
      createModal: { title: 'Nouvelle routine de monétisation' },
      editModal: { title: 'Modifier la routine de monétisation' },
      deleteModal: {
        title: 'Supprimer la routine « %{name} » ?',
        consequencesTitle: 'Conséquences de la suppression',
        consequencePatternRemoved:
          'Les chaînes utilisant cette routine perdront leur routine de monétisation.',
        consequenceAutoMonetizationDisabled:
          'Leur auto-monétisation sera désactivée automatiquement (une alerte Slack sera envoyée).',
        consequenceReconfigure:
          "Choisissez une autre routine sur ces chaînes puis réactivez l'auto-monétisation.",
        confirm: 'Supprimer la routine',
      },
      create: {
        title: 'Routine créée',
        message: 'La routine « %{name} » a été créée.',
        button: 'Nouvelle routine',
      },
      update: {
        title: 'Routine modifiée',
        message: 'La routine « %{name} » a été mise à jour.',
      },
      delete: {
        title: 'Routine supprimée',
        message: 'La routine « %{name} » a été supprimée.',
      },
      errors: {
        nameRequired: 'Le nom est requis',
        invalidTimecode: 'Timecode invalide (format mm:ss)',
        recurringBothRequired: 'Les deux champs doivent être remplis ensemble',
      },
    },
    prepayments: {
      _title: 'Avances de royautés',
      addPrepayment: 'Ajouter une avance',
      prepaymentDetails: "Détails de l'avance",
      amountInEuros: 'Montant (en €)',
      consumedInEuros: 'Montant recoupé (en €)',
      remainingInEuros: 'Restant à recouper (en €)',
      listOfConsumedInStatements: 'Liste des avances recoupées par statement',
      xStatementsBeingRegen: '%{count} statements en cours de regénération',
      followingStatementsImpactedByChanges:
        'Les statements ci-dessous seront impactés par ces changements et regénérés',
      targetType: {
        beneficiary: 'Ayant-droit',
        product: 'Collection',
        artwork: 'Oeuvre',
      } as Record<PrepaymentTargetType, string>,
      addPrepaymentModal: {
        title: "Ajout d'une avance",
        success: "L'avance a bien été créée",
        error: "Erreur de création de l'avance",
      },
      editPrepaymentModal: {
        title: "Modifier l'avance %{label}",
        tooltip: "L'avance ne peut plus être éditée car une partie a déjà été recoupée",
        success: "L'avance a bien été modifiée",
        error: "Erreur de modification de l'avance",
      },
      deletePrepaymentModal: {
        title: "Suppression d'une avance",
        description: "Êtes-vous sûr de vouloir supprimer l'avance %{label} ?",
        tooltip: "L'avance ne peut plus être supprimée car une partie a déjà été recoupée",
        success: "L'avance a bien été supprimée",
        error: "Erreur de suppression de l'avance",
      },
    },
    quotas: {
      _title: 'Quotas',
      youtube: 'Youtube',
      lastUpdate: 'Dernière mise à jour',
      quotasReset: 'Réinitialisation des quotas',
      services: {
        'youtube.googleapis.com/default': {
          title: 'Data API / Global',
          description:
            'The YouTube Data API v3 is an API that provides access to YouTube data, such as videos, playlists, and channels.',
        },
        'youtube.googleapis.com/search_list': {
          title: 'Data API / Search',
          description: 'YouTube API dedicated for Search queries',
        },
        'youtube.googleapis.com/video_insert': {
          title: 'Data API / Video Insert',
          description: 'YouTube API dedicated for Video insertion queries',
        },
        'youtubepartner.googleapis.com/default': {
          title: 'Partner API (Content ID)',
          description:
            'API "privée" de YouTube avec laquelle est géré tout le Content Management : création et liste de claims, d\'assets, gestion de la monétisation…',
        },
        'youtubereporting.googleapis.com/free_quota_requests': {
          title: 'Reporting API',
          description:
            'Téléchargement automatique des rapports - Schedules reporting jobs containing your YouTube Analytics data and downloads the resulting bulk data reports in the form of CSV files.',
        },
      },
    },
    exports: {
      _title: 'Exports',
      scam: 'SCAM',
      videoDuration: 'Durée de la vidéo',
      savePreset: 'Sauvegarder un preset',
      updatePreset: 'Mettre à jour le preset',
      presetName: 'Nom du preset',
      exportProgress: "Progression de l'export",
      exportInProgress: 'Export en cours',
      startPeriod: 'Début de période',
      endPeriod: 'Fin de période',
      toast_createPresetSuccess: 'Le preset a été créé avec succès',
      toast_createPresetError: 'Erreur lors de la création de preset',
      toast_updatePresetSuccess: 'Le preset a été mis à jour avec succès',
      toast_updatePresetError: 'Erreur lors de la mise à jour du preset',
      toast_exportSuccess: 'Le fichier a été exporté avec succès',
      toast_exportError: "Erreur lors de la création de l'export",
    },
    videoPromotion,
    users,
    mediaFiles,
  },
  errors: {
    invalidEmail: 'Email non valide',
    error__duplicate_beneficiary_code: 'Erreur - Code ayant-droit déjà utilisé',
  },
  placeholders: {
    email: 'Veuillez entrer une adresse email',
    name: 'Veuillez entrer un nom',
    presetName: 'Veuillez entrer un nom de preset',
  },
}
